"use strict";
exports.__esModule = true;
exports.GdcDashboardLayout = void 0;
var tslib_1 = require("tslib");
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
/**
 * @public
 */
var GdcDashboardLayout;
(function (GdcDashboardLayout) {
    function isFluidLayout(obj) {
        return !isEmpty_1["default"](obj) && !!obj.fluidLayout;
    }
    GdcDashboardLayout.isFluidLayout = isFluidLayout;
    function isLayoutWidget(obj) {
        return !isEmpty_1["default"](obj) && !!obj.widget;
    }
    GdcDashboardLayout.isLayoutWidget = isLayoutWidget;
})(GdcDashboardLayout = exports.GdcDashboardLayout || (exports.GdcDashboardLayout = {}));
//# sourceMappingURL=GdcDashboardLayout.js.map